module.exports = __webpack_public_path__ + "static/media/OrderswiftLogoFull.43d639f1.svg";